import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { TelemetryService } from "@obg/ngx.global.evo";
import { filter, map, tap } from "rxjs/operators";

import { COOKIE_CONSENT_ACTION_TYPE } from "../../data-protection/cookie-consent/cookie-consent.action";
import { UpdateConsentPayload } from "../../data-protection/cookie-consent/cookie-consent.model";
import { MARKETING_SETTINGS_ACTION_TYPE } from "../../data-protection/marketing-settings/marketing-settings.action";
import {
	Consents,
	MarketingSettingsWithTokenRequest,
} from "../../data-protection/marketing-settings/marketing-settings.model";

import { DataProtectionEventName } from "./data-protection-telemetry.model";
import { DataProtectionTelemetryService } from "./data-protection-telemetry.service";

@Injectable()
export class DataProtectionTelemetryEffect {
	// TODO [OneTrust]:
	// This file needs to be refactored once oneTrust is rolled out on all the brands: https://edgealpha.corpsson.com/browse/AOCC-3162
	consent$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(COOKIE_CONSENT_ACTION_TYPE.update),
				map((data: ActionWithPayload<UpdateConsentPayload>) => data.payload),
				filter((updatedConsent) => updatedConsent.shouldSendGTM),
				map((updateConsent) => updateConsent.consentProperties),
				tap((userConsent) => this.dataProtectionService.sendDataProtectionEvents(userConsent))
			),
		{ dispatch: false }
	);

	marketingConsentSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(MARKETING_SETTINGS_ACTION_TYPE.updateMarketingSettingsWithTokenSuccess),
				map((data: ActionWithPayload<MarketingSettingsWithTokenRequest>) => data.payload),
				tap((marketingSettings) =>
					this.service.track({
						event: DataProtectionEventName.ConsentConfirmed,
						ConsentFields: this.getTrueConsentsAsString(marketingSettings.consents),
					})
				)
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private service: TelemetryService,
		private dataProtectionService: DataProtectionTelemetryService
	) {}

	private getTrueConsentsAsString(consents: Partial<Consents>): string {
		return Object.getOwnPropertyNames(consents)
			.filter((k: keyof Consents) => consents[k])
			.join(" - ");
	}
}
